module.exports = __webpack_public_path__ + "img/bag.09254a8a.png";